let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ktE9k")).then(() => parcelRequire('hxTpR'));